<template>
    <LoadingCard v-if="!(packages.length > 0 && currentUser)" />
    <div v-else>
        <div class="toolbar">
            <div class="toolbar__label">
                Package Subscriptions
            </div>
        </div>

        <div class="row price-table price-table--basic">
            <div class="col-md-4" v-for="pkg in packages" :key="pkg.id">
                <div class="price-table__item">
                    <header class="price-table__header bg-primary">
                        <div class="price-table__title">{{ pkg.name }}</div>
                        <div class="price-table__desc">{{ pkg.description }}</div>
                    </header>
                    <div class="price-table__price color-light-blue">
                        {{ pkg.price | money_format }} |
                        <small>month</small>
                    </div>
                    <ul class="price-table__info">
                        <li v-for="feature in pkg.features">{{ feature.title }}</li>
                        <li class="text-danger" v-if="trialExpired(pkg)">
                            Your trial expired on {{ currentSubscription(pkg).trial_ends_on | date_format }}
                        </li>
                        <li class="text-warning" v-if="trialActive(pkg)">
                            Trial ends on {{ currentSubscription(pkg).trial_ends_on | date_format }}
                        </li>
                        <li class="text-warning" v-if="cancelled(pkg)">
                            You cancelled this on {{ currentSubscription(pkg).cancelled_on | date_format }}
                        </li>
                        <li class="text-success" v-if="purchased(pkg)">
                            You purchase this on {{ currentSubscription(pkg).purchased_on | date_format }}
                        </li>
                        <li class="text-success" v-if="trialAvailable(pkg)">
                            <strong>Free</strong> 30 day trial available!
                        </li>
                    </ul>
                    <button class="btn price-table__action bg-danger"
                            @click.prevent="updateSubscription(pkg, 'cancel')"
                            v-if="cancelAvailable(pkg)">
                        Cancel
                    </button>
                    <button class="btn price-table__action bg-primary"
                            @click.prevent="updateSubscription(pkg, 'start_trial')"
                            v-if="trialAvailable(pkg)">
                        Start Free Trial
                    </button>
                    <button class="btn price-table__action bg-primary"
                            @click.prevent="updateSubscription(pkg, 'purchase')"
                            v-if="purchaseAvailable(pkg)">
                        Purchase
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import updateSubscriptionMutation from '@views/Setup/PackageManager/mutationUpdateSubscription.graphql';
import currentUserQuery from '@views/Setup/PackageManager/queryCurrentUser.graphql';
import listPackagesQuery from '@views/Setup/PackageManager/queryListPackages.graphql';

export default {
  name: 'PackageManager',
  apollo: {
    packages: {
      query: listPackagesQuery,
      update: data => data.filterPackages,
    },
    currentUser: {
      query: currentUserQuery,
      update: data => data.currentUser,
    },
  },
  data() {
    return {
      delayed: false,
      packages: [],
      currentUser: null,
      loading: 0,
    };
  },
  computed: {},
  mounted() {
    setTimeout(() => this.delayed = true, 5000);
  },
  methods: {
    currentSubscription(pkg) {
      return this.currentUser.subscriptions.find(sub => sub.package_id === pkg.id);
    },

    trialActive(pkg) {
      const currentSubscription = this.currentSubscription(pkg);
      return currentSubscription && currentSubscription.status === 'trial_active';
    },

    trialAvailable(pkg) {
      const currentSubscription = this.currentSubscription(pkg);
      return !currentSubscription;
    },

    purchaseAvailable(pkg) {
      const currentSubscription = this.currentSubscription(pkg);
      return !(currentSubscription && currentSubscription.status === 'purchased');
    },

    cancelAvailable(pkg) {
      const currentSubscription = this.currentSubscription(pkg);
      return currentSubscription && ['purchased', 'trial_active'].includes(currentSubscription.status);
    },

    trialExpired(pkg) {
      const currentSubscription = this.currentSubscription(pkg);
      return currentSubscription && currentSubscription.status === 'trial_expired';
    },

    purchased(pkg) {
      const currentSubscription = this.currentSubscription(pkg);
      return currentSubscription && currentSubscription.status === 'purchased';
    },

    cancelled(pkg) {
      const currentSubscription = this.currentSubscription(pkg);
      return currentSubscription && currentSubscription.status === 'cancelled';
    },

    updateSubscription(pkg, action) {
      console.log('Updating subscription', pkg.id, action);
      this.$apollo.mutate({
          mutation: updateSubscriptionMutation,
          variables: {
            input: {
              user_id: this.currentUser.id,
              package_id: pkg.id,
              action: action,
            },
          },
          update: (store, { data: { updatePackageSubscription: subscription } }) => {
            const data = store.readQuery({ query: currentUserQuery });
            const itemIndex = data.currentUser.subscriptions.findIndex(item => item.id === subscription.id);
            if (itemIndex === -1) {
              data.currentUser.subscriptions.push(subscription);
            } else {
              data.currentUser.subscriptions.splice(itemIndex, 1, subscription);
            }
            store.writeQuery({ query: currentUserQuery, data });
          },
        })
        .then(() => {
          this.$refreshFeatures();
          this.$notifySuccess('Package status updated!');
        })
        .catch(err => {
          this.$mapGraphQLError(err);
        })
        .catch(err => {
          console.error(err);
          this.$notifyFailure('Unfortunately, we were unable to do that!');
        });
    },
  },
};
</script>
